<template>
  <div class="inventory page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Condition Report Requests')">

    </page-header>
    <div class="card content-wrapper p-2">
      <ConditionReportRequestsTable :exclude-header-actions="excludeActions" :exclude-search-fields="excludeSearchFields"/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "../../core/components/page-header/PageHeader";
  import ConditionReportRequestsTable from "@/modules/condition-report-requests/ConditionReportRequestsTable.vue";

  const {mapActions, mapState} = createNamespacedHelpers('conditionReportRequests');

  export default {
    name: "Inventory",
    components: {
      ConditionReportRequestsTable,
      PageHeader,
    },
    data: () => {
      return {
        isUploading: false,
        excludeActions: [],
        excludeSearchFields: []
      }
    },
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource],
      })
    },
    methods: {
      ...mapActions(['showModal', 'updateTableSource']),
      onCreateClick() {
        this.showModal();
      },
    },
    async beforeMount() {
      await this.updateTableSource({extraFilters: {}, source: 'global'});
    }
  }
</script>

<style lang="scss" scoped>
</style>
